import React from 'react';

const AsyncMailerTemplatePage = React.lazy(() => import('./MailerTemplateContainer'));

export const MailerTemplatePage = () => {
  return <AsyncMailerTemplatePage />;
};
